function toPreviewUrl(url: string) {
  return url.replace('/watermarked/', '/preview/');
}

export default toPreviewUrl;
